rdefine('app/components/options',['backbone','text!events/options.html'], function(Backbone,template) {

    var ItemView = Backbone.Ribs.View.extend({
        tagName:'li',
        className:'',
        bindings:{
            el:{
                text:'model.title'
            }
        },
        initialize:function(opts) {

        }
    });

    var EventsDisplay = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'options-display',
        bindings:{
            el:{
                collection:{
                    col:'ilist',
                    view:ItemView
                }
            }
        },
        initialize:function(opts) {
            this.input = opts.input;
            this.ilist = opts.ilist;
            $("body").append(this.el);
        },
        show:function() {
            var offset = this.input.offset();
            var w = this.input.outerWidth();
            var h =this.input.outerHeight();
            this.$el.css({top:offset.top + h,left:offset.left, 'min-width':w+'px'});
            this.$el.addClass("show");
        },
        filter: function(val) {

        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'form-group',
        input:null,

        events:{
            'focus input':'onFocus',
            'blur input':'onBlur',
            'keydown input':'onKey'
        },
        display:null,
        ilist:null,
        initialize:function(opts) {
            this.ilist = opts.ilist;
            this.$el.html(Template7.compile(template)({placeholder:opts.placeholder || '-'}));
            this.input = this.$el.find("input");

        },
        onFocus: function() {
            if(this.display) {
                this.display.show();
                return;
            }
            this.display = new EventsDisplay({input:this.input, ilist:this.ilist});
            this.display.show();
        },
        onBlur: function() {
            if(this.display) {
                //this.display.remove();
                //this.display = null;
            }
        },
        onKey:function() {
            if(this.display) {
                this.display.filter(this.input.val());
            }
        }
    });
});
